import React from 'react';
import { Box, IconButton, Typography, makeStyles } from '@material-ui/core';
import { MinusIcon, PlusIcon } from './adsAgentIcons';
import { AD } from './adsAgentTokens';

// Read-only port of whatsapp-console-frontend
// `src/pages/AdTemplates/StatStepper.js`: same look, value cannot change.

const ICON = 12;

const useStyles = makeStyles(() => ({
  wrap: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    padding: '0 8px',
    height: AD.controlHeight,
    borderRadius: AD.radius,
    background: '#f5f5f5',
  },
  label: {
    fontSize: 10.5,
    fontWeight: 600,
    color: AD.textMuted,
    lineHeight: 1.2,
    marginBottom: 5,
    textAlign: 'left',
    paddingLeft: 2,
  },
  valueRow: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    gap: 1,
  },
  value: {
    fontSize: 11,
    fontWeight: 700,
    color: AD.text,
    lineHeight: 1.25,
  },
  unit: { fontSize: 9, fontWeight: 400, color: AD.textMuted, flexShrink: 0 },
  button: {
    width: 18,
    height: 18,
    padding: 0,
    boxSizing: 'border-box',
    borderRadius: AD.radiusPill,
    background: AD.surface,
    color: AD.cta,
    flexShrink: 0,
    '&.Mui-disabled': { background: AD.surface, color: AD.textHint },
  },
}));

const StatStepper = (props: Props): React.ReactElement => {
  const { label, value, unit } = props;
  const classes = useStyles();

  return (
    <Box className={classes.wrap}>
      <Typography className={classes.label}>{label}</Typography>
      <Box className={classes.root}>
        <IconButton className={classes.button} size="small" disabled aria-hidden="true">
          <MinusIcon size={ICON} />
        </IconButton>
        <Box className={classes.valueRow}>
          <span className={classes.value}>{value}</span>
          {unit ? <span className={classes.unit}>{unit}</span> : null}
        </Box>
        <IconButton className={classes.button} size="small" disabled aria-hidden="true">
          <PlusIcon size={ICON} />
        </IconButton>
      </Box>
    </Box>
  );
};

interface Props {
  label: string;
  value: string;
  unit?: string;
}

export default StatStepper;
